import { CashDeskCloseControlSearchItem } from '../../../../model/cash-desk-close-control/cash-desk-close-control-search-item';
import { KeyedCollection } from '../../../../infrastructure/keyed-collection';
import { CashDeskCloseControlPayment } from '../../../../model/cash-desk-close-control/cash-desk-close-control-payment';
import { CashDeskPaymentFilter } from '../../../../model/cash-desk-payment-filter';
import { CashDeskCloseControlPaymentTotal } from '../../../../model/cash-desk-close-control/cash-desk-close-control-payment-total';
export class CashDeskCloseControlPaymentTotalized {

    cashDeskCloseControlPaymentTotals: CashDeskCloseControlPaymentTotal[] = [];

    constructor(private cashDeskPaymentFilter: CashDeskPaymentFilter[],
        private cashDeskCloseControlSearchItem: CashDeskCloseControlSearchItem[]) {
            this.cashDeskCloseControlPaymentTotals = [];
            const cashDeskCloseControlPayments: CashDeskCloseControlPayment[] = [];
            this.cashDeskCloseControlSearchItem.forEach((item) => {
                item.CashDeskCloseControlPayments.forEach((payment) => {
                    cashDeskCloseControlPayments.push(payment);
                });
            });

            this.cashDeskPaymentFilter.forEach((item) => {
               const payments = cashDeskCloseControlPayments.filter(p => p.PaymentId === item.Id);
               const total = new CashDeskCloseControlPaymentTotal(item, payments);
               this.cashDeskCloseControlPaymentTotals.push(total);
            });
    }

    getCashDeskCloseControlPaymentTotals(): CashDeskCloseControlPaymentTotal[] {
        return this.cashDeskCloseControlPaymentTotals;
    }
}